import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../context/ToastContext';
import { API_URL } from '../../config/api';
import './SaveComparisonModal.css';

const SaveComparisonModal = ({ isOpen, onClose, compareList, globalOverrides, columns, perColumnAssumptions, onSaved }) => {
    const { session } = useAuth();
    const { showToast } = useToast();
    const [name, setName] = useState('');
    const [saving, setSaving] = useState(false);

    if (!isOpen) return null;

    const handleSave = async () => {
        if (!name.trim()) {
            showToast('Please enter a comparison name', 'error');
            return;
        }

        setSaving(true);
        try {
            const savedColumns = columns.map(col => ({
                columnId: col.columnId,
                propertyId: col.propertyId,
                scenarioId: col.scenarioId,
                scenarioName: col.scenarioName,
                assumptions: perColumnAssumptions[col.columnId] || {},
            }));

            const response = await fetch(`${API_URL}/comparisons`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${session?.access_token}`
                },
                body: JSON.stringify({
                    name: name.trim(),
                    property_ids: compareList.map(p => p.property_id),
                    global_overrides: globalOverrides,
                    columns: savedColumns
                })
            });

            if (response.ok) {
                showToast('Comparison saved!', 'success');
                setName('');
                onSaved?.();
                onClose();
            } else {
                showToast('Failed to save comparison', 'error');
            }
        } catch (error) {
            console.error(error);
            showToast('Error saving comparison', 'error');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="save-comparison-modal" onClick={e => e.stopPropagation()}>
                <h3 className="scm-title">Save Comparison</h3>
                <p className="scm-subtitle">
                    Save this {compareList.length}-property comparison with all your assumptions.
                </p>

                <div className="scm-field">
                    <label>Comparison Name</label>
                    <input
                        type="text"
                        className="std-input"
                        placeholder="e.g. Des Moines Rentals, Top 3 Picks..."
                        value={name}
                        onChange={e => setName(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && handleSave()}
                        autoFocus
                    />
                </div>

                <div className="scm-actions">
                    <button className="scm-btn-cancel" onClick={onClose}>Cancel</button>
                    <button
                        className="scm-btn-save"
                        onClick={handleSave}
                        disabled={saving}
                    >
                        {saving ? 'Saving...' : 'Save'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SaveComparisonModal;
